enum Colors {
    darkGrey = '#8D969F',
    grey = '#EFEEF4',
    lightGrey = '#F7FAFC',
    lightGrey2 = '#C4CDD6',
    lightOrange = '#FCE5CA',
    orange = '#F59622',
    lightBlue = '#ACDBF5',
    blue = '#2A86AD',
    lightGreen = '#E0FFB4',
    darkGreen = 'rgba(90, 135, 29, 1)',
    green = 'rgba(90, 135, 29, 1)',
    lightRed = '#FFE1E1',
    red = '#FF8F8F',
    darkBlue = '#121B24',
    darkBlue2 = '#1C2838',
}

export default Colors;
